import React, { useState, useEffect } from "react";
import { SidePopup } from "../../../components/model-popup/side-popup";
import { CustomButton } from "../../../components/buttons/button";
import TextIconInput from "../../../components/custom-fields/input";
import Table from "../../../components/table/table";

import SearchIcon from "../../../assets/icons/search-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchSearchPatientList } from "../../../redux/slices/patientlookup.slice";
import { WordTitle } from "../../../utils/commonFunction";
import { toast } from "react-toastify";
import { ConfirmPopup } from "../../../components/model-popup/confirmation-popup";
import { UpdateNotesErrorByPatientDetailsAPI } from "../../../api/create";
import NotesDocs from "../notes_docs";

export const PatientUpdatePopup = (props: any) => {
    const dispatch: any = useDispatch();
    const {
        showModal,
        setShowModal,
        handleClose,
        poupDetails,
        afterChangeNotesList,
    } = props;


    const [buttonLoader, setButtonLoader] = useState<boolean>(false);
    const [showSearchPatientName, setShowSearchPatientName] = useState<string | null>(null);
    const [searchPatientName, setSearchPatientName] = useState<string | null>(null);
    const [searchedDate, setSearchedDate] = useState<string | null>(null);
    const searchPatientList = useSelector(
        (state: any) => state.patientlookUp?.searchPatientList || []
    );

    const [mappedPatientDetails, setMappedPatientDetails] = useState<any>({})

    // table
    const [loader, setLoader] = useState<boolean>(true);
    const [notesLoader, setNotesLoader] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [totalPage, setTotalPage] = useState<number>(1);
    const [sort, setSort] = useState<string>("lastName");
    const [sortDir, setSortDir] = useState<string>("asc");
    //eslint-disable-next-line
    //@ts-ignore
    const [limit, ] = useState<number>(15);

    // confirm model
    const [showConfirmModel, setShowConfirmModel] = useState<boolean>(false);

   
    //eslint-disable-next-line
    //@ts-ignore
    const [, setTotalRecord] = useState<number>(0);

    const handlePatientListData = (param: any = {}) => {
        const apiParam = {
            page: page,
            name: searchPatientName,
            sort: sort,
            sort_dir: sortDir,
            limit: limit,
            DOB: searchedDate
        }
        if ('page' in param) {
            setPage(param?.page);
            apiParam['page'] = param['page']
        }
        if ('sort' in param) {
            apiParam['sort'] = param['sort'];
            apiParam['sort_dir'] = param['sortDir'];
            apiParam['page'] = 1
            setSort(param['sort'])
            setSortDir(param['sortDir'])
            setPage(1)
        }
        if ('DOB' in param) {
            setSearchedDate(param['DOB']);
            apiParam['DOB'] = param['DOB'];
            apiParam['page'] = 1
            setPage(1)
        }
        if ('search' in param) {
            setSearchPatientName(param?.search);
            apiParam['name'] = param['search'];
            apiParam['page'] = 1
            setPage(1)
        }
        if (apiParam['page'] === 1) {
            setLoader(true)
        }
        dispatch(
            fetchSearchPatientList(apiParam)
        ).then((res: any) => {
            setTotalPage(res?.payload?.total_pages);
            setTotalRecord(res?.payload?.total_count);
            setLoader(false);
        });
    }

    const handleNextPage = () => {
        handlePatientListData({ 'page': page + 1 });
    };

    const setSelectedPatient = (row: any) => {
        setMappedPatientDetails(row)
    }

    const handleBirthDate = (value: string | null) => {
        if (value) {
            handlePatientListData({ 'DOB': value })
        } else {
            handlePatientListData({ 'DOB': null })
        }
    }

    const updatePatientDetailConfirm = () => {
        if (mappedPatientDetails?.id) {
            setShowConfirmModel(true)
        } else {
            toast.error("please map patient");
        }
    }

    const updatePatientDetail = async () => {
        setButtonLoader(true)
        const payload = {
            patient_id: mappedPatientDetails?.id,
            notes_id: poupDetails?.id
        }
        await UpdateNotesErrorByPatientDetailsAPI(payload).then(async (res: any) => {
            if (res?.success) {
                toast.success(res?.message);
                setButtonLoader(false)
                handlePatientListData({ page: 1 })
                setMappedPatientDetails({})
                setShowConfirmModel(false)
                setShowModal(false)
                resetState()
                afterChangeNotesList()
            } else {
                toast.error(res?.message || res?.detail?.message || "Update patient details failed");
                setButtonLoader(false)
            }
        })
    }

    const resetState = () => {
        setSearchedDate(null)
        setShowSearchPatientName(null)
        setSearchPatientName(null)
        setSort('lastName')
        setSortDir('asc')
    }



    useEffect(() => {
        if (showModal) {
            handlePatientListData({ page: 1 })
            setMappedPatientDetails({})
            setShowConfirmModel(false)
            resetState()
            // Prevent body scroll when popup is open
            document.body.style.overflow = 'hidden';
        } else {
            // Restore body scroll when popup is closed
            document.body.style.overflow = 'unset';
        }
        
        // Cleanup function to restore scroll on unmount
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showModal])

    useEffect(() => {
        const handler = setTimeout(() => {
            handlePatientListData({ search: showSearchPatientName });
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [showSearchPatientName]);

    return (
        //eslint-disable-next-line
        //@ts-ignore

        <SidePopup
            showModal={showModal}
            handleClose={() => {
                handleClose();
                // Restore body scroll when popup is closed
                document.body.style.overflow = 'unset';
            }}
            width="max-w-full"
            title={'Update Patient Details'}
            closeIcon={false}
            footerStyle="flex justify-end gap-[16px]"
            footerContent={showConfirmModel ? null : (
                <>
                    <CustomButton
                        buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1] px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4]"
                        buttonName="Cancel"
                        primary={false}
                        disable={buttonLoader}
                        onClick={() => {
                            setShowModal(false);
                            document.body.style.overflow = 'unset';
                        }}
                    />
                    <CustomButton
                        type="submit"
                        loader={buttonLoader}
                        loaderStyle={`px-[40.5px] py-[13px] leading-[17px]`}
                        primary={true}
                        disable={buttonLoader}
                        buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]"
                        buttonName={"Update"}
                        onClick={() => {
                            updatePatientDetailConfirm();
                        }}
                    />
                </>)
            }
        >


            <div className="grid grid-cols-[39%_59%] gap-1 h-[calc(100vh-175px)] overflow-y-auto gap-y-2">
                

                <NotesDocs id={poupDetails?.id} />

                <div className="border border-gray-200 rounded-lg shadow-sm p-4 scrollable-hidden  overflow-y-auto"
                    >
                    <div className="font-normal text-center mb-2 text-gray-800 text-lg bg-gray-200 py-2 px-4 rounded">
                        Source Information
                    </div>
                    <div className="grid grid-cols-[30%_70%] mt-1 gap-y-1 bg-blue-50 p-2 rounded text-sm">
                        <div className="font-medium">Location:</div>
                        <div className="max-w-[250px] truncate">
                            {poupDetails?.location || 'N/A'}
                        </div>
                        <div className="font-medium">Sender:</div>
                        <div className="max-w-[250px] truncate">
                            {WordTitle(poupDetails?.sender_name || '') || 'N/A'}
                        </div>
                    </div>
                    
                    {/* Source Data Section - Location and Sender */}
                    <div className="mt-3 pt-2 border-t border-gray-200">
                        <div className="font-normal text-center mb-2 text-gray-800 text-base bg-gray-200 py-2 px-4 rounded">Patient Details Comparison</div>

                        <hr className="my-2 shadow-md" />
                        <div className="space-y-1">
                            {/* Grid Header */}
                            <div className="grid grid-cols-[25%_37%_37%] gap-1 mb-1 bg-gray-100 p-1 rounded text-xs">
                                <div className="font-semibold text-gray-700">Field</div>
                                <div className="font-semibold text-gray-700 text-center">Current</div>
                                <div className="font-semibold text-gray-700 text-center">Selected</div>
                            </div>
                            
                            {/* Patient Name Row */}
                            <div className="grid grid-cols-[25%_37%_37%] gap-1 py-1 border-b border-gray-100">
                                <div className="font-medium text-sm py-1">Patient:</div>
                                <div className="max-w-full truncate text-center bg-gray-50 px-2 py-1 rounded text-xs">
                                    {![null, "", undefined].includes(poupDetails?.patient_last_name) && ![null, "", undefined].includes(poupDetails?.patient_first_name)
                                        ? `${WordTitle(poupDetails?.patient_last_name || '')}, ${WordTitle(poupDetails?.patient_first_name || '')}`
                                        : (WordTitle(poupDetails?.patient_last_name || '') || WordTitle(poupDetails?.patient_first_name || '') || 'N/A')}
                                </div>
                                <div className="max-w-full truncate text-center bg-gray-50 px-2 py-1 rounded text-xs">
                                    {mappedPatientDetails && ![null, "", undefined].includes(mappedPatientDetails?.lastName) &&
                                        ![null, "", undefined].includes(mappedPatientDetails?.firstName)
                                        ? `${WordTitle(mappedPatientDetails?.lastName || '')}, ${WordTitle(mappedPatientDetails?.firstName || '')}`
                                        : (WordTitle(mappedPatientDetails?.lastName || '') || WordTitle(mappedPatientDetails?.firstName || '') || 'No patient selected')}
                                </div>
                            </div>
                            
                            {/* Birthday Row */}
                            <div className="grid grid-cols-[25%_37%_37%] gap-1 py-1 border-b border-gray-100">
                                <div className="font-medium text-sm py-1">Birthday:</div>
                                <div className="max-w-full truncate text-center bg-gray-50 px-2 py-1 rounded text-xs">
                                    {poupDetails?.DOB || 'N/A'}
                                </div>
                                <div className="max-w-full truncate text-center bg-gray-50 px-2 py-1 rounded text-xs">
                                    {mappedPatientDetails?.birthDate || 'N/A'}
                                </div>
                            </div>
                            
                            {/* Gender Row */}
                            <div className="grid grid-cols-[25%_37%_37%] gap-1 py-1">
                                <div className="font-medium text-sm py-1">Gender:</div>
                                <div className="max-w-full truncate text-center bg-gray-50 px-2 py-1 rounded text-xs">
                                    {WordTitle(poupDetails?.gender || '') || 'N/A'}
                                </div>
                                <div className="max-w-full truncate text-center bg-gray-50 px-2 py-1 rounded text-xs">
                                    {WordTitle(mappedPatientDetails?.gender || '') || 'N/A'}
                                </div>
                            </div>
                        </div>


                    </div>
                    
                    <hr className="my-2 shadow-md" />
                    <div className="font-normal text-center mb-2 text-gray-800 text-base bg-gray-200 py-2 px-4 rounded">Search Patient</div>
                    <hr className="my-1 shadow-md" />
                    
                    {/* Search Controls */}
                    <div className=" mb-3 grid grid-cols-2 gap-x-5">
                        <TextIconInput
                            placeholder="patient name"
                            label="Patient name"
                            divStyle=""
                            onChange={(e: any) => {
                                if (setShowSearchPatientName){
                                    setShowSearchPatientName(e.target.value)
                                }
                            }}
                            inputStyle="w-full border-[#E8ECF4] border-[0.5px] rounded-[8px] !h-[40px]"
                            icon={SearchIcon}
                            value={showSearchPatientName || ''}
                            setShowSearch={setShowSearchPatientName}
                            clearSearch={() => {
                                setShowSearchPatientName('')
                            }}
                            iconStyle="w-[16px] h-[16px] bottom-[10px] right-[8px] border-none rounded-[0px]"
                        />

                        <TextIconInput
                            divStyle=""
                            label={"Date of birth"}
                            minLength={4}
                            placeholder="Patient date of birth"
                            maxLength={50}
                            name="DOB"
                            id="DOB"
                            inputStyle=" !h-[40px]"
                            value={searchedDate || ''}
                            onChange={(e: any) => {
                                handleBirthDate(e.target.value);
                            }}
                            type={"date"}
                        />
                    </div>
                {/* </div>
                <div className="border border-gray-200 rounded-lg shadow-sm p-2"> */}
                    <div className="font-normal text-center mb-2 text-gray-800 text-base bg-gray-200 py-2 px-4 rounded">Patient List</div>
                    <hr className="my-1 shadow-md" />
                    <div className="overflow-hidden" style={{ height: '330px' }}>
                        <Table
                            loading={loader}
                            data={searchPatientList}
                            tableScroll={"100%"}
                            tableHeight={330}
                            sort={true}
                            Clickable={true}
                            pageSecondTableIndentifyClass="patientUpdateScrollableDiv"
                            rowClick={(row: any) => {
                                setSelectedPatient(row)
                            }}
                            hasNextPage={page < totalPage}
                            NextPageData={handleNextPage}
                            columns={[
                                "Patient",
                                "DOB",
                                "Gender",
                                "Location"
                            ]}
                            sortTitleKeys={{
                                Patient: "lastName",
                                Gender: "gender"
                            }}
                            handleSortfunc={(key: any, value: any) => {
                                handlePatientListData({ 'sort': key, 'sortDir': value })
                            }}
                            rowSpecificClass={(row: any) => row?.id === mappedPatientDetails?.id ? ' bg-[#EDF8F9] hover:!bg-[#d1f0ea]' : ''}
                            scopedSlots={{
                                Patient: ({ row }: any) => (
                                    <td title={`${WordTitle(row?.lastName || '')}, ${WordTitle(row?.firstName || '')}`}>
                                        <div className="max-w-[500px] truncate cursor-pointer">
                                            {WordTitle(row?.lastName || '')}, {WordTitle(row?.firstName || '')}
                                        </div>
                                    </td>
                                ),
                                "DOB": ({ row }: any) => (
                                    <td title={row?.birthDate || ""}>
                                        <div className="max-w-[500px] truncate cursor-pointer">
                                            {row?.birthDate || 'N/A'}
                                        </div>
                                    </td>
                                ),
                                Gender: ({ row }: any) => (
                                    <td title={row?.gender || ""}>
                                        <div className="max-w-[500px] truncate cursor-pointer">
                                            {WordTitle(row?.gender || '') || 'N/A'}
                                        </div>
                                    </td>
                                ),
                                "Location": ({ row }: any) => (
                                    <td title={row?.other_location?.join(', ') || row?.location || ""}>
                                        <div className="max-w-[500px] truncate cursor-pointer">
                                            {WordTitle(row?.other_location?.join(', ') || row?.location || '') || 'N/A'}
                                        </div>
                                    </td>
                                )
                            }}
                        />
                    </div>
                </div>
                {/* <div className="col-span-1">

                </div> */}
                <ConfirmPopup showModal={showConfirmModel} icon>
                    <div className="text-[16px] font-semibold text-center text-[#061018] line-height-[24px]">
                        Map Patient?
                    </div>
                    <div className="text-[12px] font-normal text-center text-[#061018] mt-[8px] mb-[16px] ">
                        <div className="grid grid-cols-[30%_max-content_max-content] gap-y-10px  text-left">
                            <div className=" font-medium">Patient :</div>
                            <div className=" max-w-[200px] truncate">

                                <div>
                                    {![null, "", undefined].includes(poupDetails?.patient_last_name) && ![null, "", undefined].includes(poupDetails?.patient_first_name)
                                        ? `${WordTitle(poupDetails?.patient_last_name || '')}, ${WordTitle(poupDetails?.patient_first_name || '')}`
                                        : (WordTitle(poupDetails?.patient_last_name || '') || WordTitle(poupDetails?.patient_first_name || ''))}
                                </div>

                            </div>
                            <div className=" max-w-[200px] truncate">

                                <div>
                                    <span className="font-semibold mx-2">to</span> {mappedPatientDetails && ![null, "", undefined].includes(mappedPatientDetails?.lastName) &&
                                        ![null, "", undefined].includes(mappedPatientDetails?.firstName)
                                        ? `${WordTitle(mappedPatientDetails?.lastName || '')}, ${WordTitle(mappedPatientDetails?.firstName || '')}`
                                        : (WordTitle(mappedPatientDetails?.lastName || '') || WordTitle(mappedPatientDetails?.firstName || '')) || ''}
                                </div>

                            </div>
                            <div className=" font-medium">Birthday :</div>
                            <div className=" max-w-[200px] truncate">{poupDetails?.DOB ? poupDetails?.DOB : ''}</div>
                            <div className=" max-w-[200px] truncate"> <span className="font-semibold mx-2">to</span> {mappedPatientDetails?.birthDate ? mappedPatientDetails?.birthDate : ''}</div>
                            <div className=" font-medium">Gender :</div>
                            <div className=" max-w-[200px] truncate">{WordTitle(poupDetails?.gender ? poupDetails?.gender : '')}</div>
                            <div className=" max-w-[200px] truncate"> <span className="font-semibold mx-2">to</span> {WordTitle(mappedPatientDetails?.gender ? mappedPatientDetails?.gender : '')}</div>
                        </div>
                        <div className="mt-2">
                            Are you sure you want to continue?
                        </div>
                    </div>
                    <div className="flex justify-center gap-[16px] items-center w-full">
                        <CustomButton
                            buttonName="Cancel"
                            primary={false}
                            buttonStyle="w-full text-[#1C252D] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px] hover:bg-gray-200  "
                            disable={buttonLoader}
                            onClick={() => {
                                setShowConfirmModel(false);
                            }}
                        />
                        <CustomButton
                            buttonName="Yes"
                            primary={true}
                            buttonStyle="w-full text-white  hover:bg-[#166B5E] text-[14px] p-[12px] text-[14px] font-semibold leading-[17px]   "
                            loader={buttonLoader}
                            disable={buttonLoader}
                            loaderStyle="w-full bg-[#F5F5F5]/80  py-[13px] "
                            onClick={() => {
                                updatePatientDetail()
                                setShowConfirmModel(false)
                            }}
                        />
                    </div>
                </ConfirmPopup>
            </div>

        </SidePopup>

    );
};
